import { isValidTimezone } from "@sitescene/shared";
import tzlookup from "tz-lookup";

import { isValidCoordinatePair } from "@/features/location-management/utils/shared/coordinates";

/** Resolve an IANA timezone from map coordinates, when one exists. */
export const getTimezoneFromCoordinates = (
	latitude: number,
	longitude: number,
): string | undefined => {
	if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
		return undefined;
	}
	if (!isValidCoordinatePair([longitude, latitude])) {
		return undefined;
	}

	try {
		const timezone = tzlookup(latitude, longitude);
		return isValidTimezone(timezone) ? timezone : undefined;
	} catch {
		return undefined;
	}
};
